import React from 'react'
import DefaultHeader from 'components/PurchaserFrontend/Headers/DefaultHeader';
import NotificationAlert from "react-notification-alert";
import Form from 'react-bootstrap/Form';
import Purchaser from '../../lib/Core/Backend/Controllers/Purchaser';
// core components
import UserHeader from "components/PurchaserFrontend/Headers/UserHeader.js";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Notify from "lib/Utils/Alert";
import Spinner from 'react-bootstrap/Spinner';
import Catalogs from "lib/Core/Backend/Controllers/Catalogs";
import { MotionButton } from "components/Core/MotionStrap";
import Utils from "lib/Utils/Utils";
import Auth from 'lib/Core/Backend/Controllers/Auth';
import FromValidator from "lib/Utils/FormValidator";
import PaymentOptions from "components/Purchaser/PaymentOptions";
import useCatalogs from "hooks/useCatalogs";
import ConfirmationAlertTwo from 'components/ConfirmationAlert/ConfirmationAlertTwo';
import RepresentativeUser from 'lib/Core/Backend/Controllers/RepresentativeUsers';
import ContactsCtl from 'components/Supplier/ContactsCtl';
import { useLocation,useHistory } from "react-router-dom";
import Select from 'react-select';
import PurchaserUsersManager from 'components/PurchaserFrontend/Users/PurchsaerUsersManager';
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Input,
    Container,
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label,
} from "reactstrap";

const mapKeys = {
    street: 'street',
    city: 'city',
    postalCode: 'zipcode',
    countryId: 'countryId'
}
const Profile = (props) => {

    const { purchaserId, token } = props;
    const purchaserCtl = useMemo(() => new Purchaser(token), [token]);
    const authCtl = useMemo(() => new Auth(token),[token]);
    const representativeUsersClt = useMemo(() => new RepresentativeUser(token), [token]);
    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);

    const { paymentOptions, countries } = useCatalogs()
    const catalogsCtl = useMemo(() => new Catalogs(token), [token]);
    const [searchQuery, setSearchQuery] = useState('');
    const [usersList, setUsersList] = useState([])
    const [updatedContactData,setUpdatedContactData] = useState([])
    const [contactType,setContactType] = useState([])
    const [addressModal, setAddressModal] = useState(false);
    const [purchaserData, setPurchaserData] = useState({});
    const [newEmail,setNewEmail] = useState('')
    const [newPhone,setNewPhone] = useState('')
    const [newFirstName,setNewFirstName] = useState('')
    const [newLastName,setNewLastName] = useState('')
    const [contactData,setContactData] = useState({});
    const [currentItem, setCurrentItem] = useState(10);
    const [showAlertMessage, setShowAlertMessage] = useState(false)
    const stayModal = () => setShowAlertMessage(false)
    const [confirmModal, setConfirmModal] = useState(false);
    const [reload, setReload] = useState(false);
    const [activeOp, setActiveOp] = useState('Create New');
    const [initialData, setInitialData] = useState({})
    const [contact, setContact] = useState("");
    const [editModalFlag, setEditModalFlag] = useState("");
    const [rowData,setRowData] = useState({});
    const [id,setId] = useState();
    const [fundShow,setFundShow] = useState(false);
    const [funds,setFunds] = useState([]);
    const [loader,setLoader] = useState(true);
    const [lowFund,setLowFund] = useState("");
    const [lowFundModal,setLowFundModal] = useState(false)
    const [fundsData,setFundsData] = useState({});
    const [apiUser, setApiUser] = useState(false);
    
    const [lowFundLoader,setLowFundLoader] = useState(false)
    const [permissions, setPermissions] = useState(false);
    const [userChecked,setUserChecked] = useState()
    const [contactLoader,setContactLoader] = useState(false);
    const [billingLoader,setBillingLoader] = useState(false);
    const [userLoader,setUserLoader] = useState(false);
    const [createLoader,setCreateLoader] = useState(false);
    const [editLoader,setEditLoader] = useState(false)
    const [deleteLoader,setDeleteLoader] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [activeContact, setActiveContact] = useState({});
    const [confirmLoader,setConfirmLoader] = useState(false);
    const [primaryContactModal,setPrimaryContactModal] = useState(false);
    const [primaryLoader,setPrimaryLoader] = useState(false);
    const [addLoader,setAddLoader] = useState(false);
    const [data,setData] = useState([])
    const [confirmPrimary,setConfirmPrimary] = useState(false)
    const toggleSetContact = () => setPrimaryContactModal(!primaryContactModal)
    const triggerReload = () => setReload(!reload);
    const toggleDelete = () => setDeleteModal(!deleteModal);
    const [contactOptions,setContactOption] = useState([])
    const [contactTypeId,setContactTypeId] = useState()
    const [newContactType,setNewContactType] = useState(null)
    const [userInfoModal,setUserInfoModal] = useState(false);
    const [recall,setRecall] = useState(false)

    const table = useRef();
    const userForm = useRef();
    const contactSelect = useRef();
    const primaryForm = useRef(null);
    const alert = useRef();
    const infoForm = useRef();
     const contactForm = useRef();
     const contactTypes = useRef();
    const addressData = useRef();
    const addressForm = useRef();

    const history = useHistory()
    const location = useLocation();
    const FundOpen = location.state?.FundOpen ?? false;
 
 
//     useEffect(()=>{
//      if(FundOpen === true){
//         toggleFund();
//         history.replace({
//             pathname: location.pathname,
//             state: { ...location.state, FundOpen: false }, // Or remove FundOpen key completely
//           });
//      }
//   },[FundOpen, history, location.pathname])
  

    const groups = {
        purchaser: 'PURCHASER',
        representative: 'PURCHASER_REPRESENTATIVE',
        manager: 'PURCHASER_USER_MANAGER',
        apiUser: 'PURCHASER_API_CLIENT'
    }
    const toggleConfirm = (data) => {
        setId(data?.id)
        setRowData(data);
        setConfirmModal(!confirmModal);
    }
    const toggleAddressModal = (flag) => {
        setAddressModal(!addressModal);
        setEditModalFlag(flag);
    }
    const toggleUserInfoModal = () =>{
      setUserInfoModal(!userInfoModal) 
    }

    const toggleFund = () => setFundShow(!fundShow)
    const toggleLowFund = () =>setLowFundModal(!lowFundModal)
    const togglePrimaryConfirm = () => setConfirmPrimary(!confirmPrimary)
    const handleFundView = () =>{
        toggleFund()

    }

    const setFormRef = (ref) => {
        userForm.current = ref;
        setUserChecked(ref) // Manually set the ref
        if (userForm.current) {
          
        }
      };
      
   const contactLoaderFile = () =>{
    setTimeout(() => {
      setContactLoader(false)  
    }, 1500);
   }
  const billingLoaderFile = () =>{
    setTimeout(() => {
        setBillingLoader(false);
    }, 1500);
  }

  const createLoaderFile = () =>{
    setTimeout(() => {
       setCreateLoader(false) 
    }, 1500);
  }
  const editLoaderFile = () =>{
    setTimeout(() => {
       setEditLoader(false) 
    }, 1500);
  }

  const getPurchaserFunction = () => {
    // setLoader(true)
    purchaserCtl.purchaserDetailsApi(purchaserId,currentItem, data => {
        if (!(data.error || data.errorMessage)) {
            setContactData(data)
            setPurchaserData(data)
            setLoader(false)
        }
    })
}

useEffect(() => {
    if (!!purchaserId) {
        getPurchaserFunction()
    }
}, [purchaserId, catalogsCtl, purchaserCtl,recall]);

      useEffect(() => {
        // This will run every time userChecked is updated
        if (userChecked) {
            
            userChecked.active.checked = initialData.active
         
        }
      }, [userChecked]);


  useEffect(() => {
     purchaserCtl.contactTypes(data => {
       
       if(data && !data.error){
        contactTypes.current = data;
       setContactType(data)
         if(!!purchaserId){
           purchaserCtl.contacts(purchaserId, contactData => {
             if(contactData.length === 0 ){
               setLoader(false)
             }
             if(contactData && !contactData.error){
               setLoader(false)
               setUsersList(contactData)
               setUpdatedContactData(contactData)
             } else {
               Notify(alert, 'danger', contactData.errorMessage ?? contactData.error);
             }
           });
         }
         
       } else {
         Notify(alert, 'danger', data.errorMessage ?? data.error);
       }
     })
   },[reload, purchaserCtl, purchaserId]);     
      
    const handleFundModalClose = () =>{
        setFundShow(false)
    }

    const handlelowFundClose = () =>{
        toggleLowFund()
    }
   

     const confirmDelete = () => {
        setConfirmLoader(true)
        if(purchaserId){
          purchaserCtl.removeContact(purchaserId, activeContact.id, data => {
            if(data.error || data.errorMessage){
              Notify(alert, 'danger', data.errorMessage ?? data.error)
              setTimeout(() => {
                setConfirmLoader(false)
              }, 1500);
            } else {
              setActiveContact(null);
              toggleDelete();
              triggerReload();
              Notify(alert, 'success', 'Contact succesfully deleted')
              setTimeout(() => {
                setConfirmLoader(false)
              }, 1500);
            }
          })
        }
      }


       const prepareForm = () => {
        
        if(contactForm.current){
            Utils.FillDropdown(contactForm.current.contactTypeId, contactTypes.current.filter(type => type.id !== 1), null, null, 'Select a type...')
            if(activeOp === 'Edit'){
              contactForm.current.contactEmail.disabled = true;
              if(activeContact.purchaserContactTypeId === 1){
                Utils.FillDropdown(contactForm.current.contactTypeId, contactTypes.current, null, null, 'Select a type...');
                contactForm.current.contactTypeId.disabled = true;
              }
              contactForm.current.contactTypeId.value = activeContact.purchaserContactTypeId.toString();
              contactForm.current.contactFirstName.value = activeContact.contactFirstName;
              contactForm.current.contactLastName.value = activeContact.contactLastName;
              contactForm.current.contactPhone.value = activeContact.phone;
              contactForm.current.contactMobile.value = activeContact.mobile;
              contactForm.current.contactEmail.value = activeContact.email;
              contactForm.current.contactId.value = activeContact.id;
            //   contactForm.current.userId.value = activeContact?.userId ?? null;
              
              authCtl.checkIfUserExists(activeContact.email, data => {
                if(data.valueOf()){
                  
                  Notify(alert, 'info', 'This contact\'s address Email is associated to a User and cannot be edited');
                } else {
                  contactForm.current.contactEmail.disabled = false;
                }
              });
            }
          }
        }

     
	const fetchPurchaserData = ()=> {
      purchaserCtl.purchaserCheck(purchaserId?`${purchaserId}`:0, (data) => {
 
        if (data && !data.error) {
       if(data?.users[0]?.enabled == false){
              sessionStorage.removeItem("accessToken")
                window.location.href="purchaser-auth/login"
        }
        }else{
         if((data?.errorMessage=="Purchaser not found"&& data?.errorCode=="BAD_REQUEST") || data?.errorMessage=="There is no records on the Purchaser brand limits table"){

            Notify(alert, 'danger', data?.errorMessage ?? data?.error);
                sessionStorage.removeItem("accessToken")
                window.location.href="purchaser-auth/login"
            }
            if((data?.errorMessage.includes("Username was not found") && data?.errorCode=="BAD_REQUEST") || data?.errorMessage=="There is no records on the Purchaser brand limits table"){
      
              Notify(alert, 'danger', data?.errorMessage ?? data?.error);
                  sessionStorage.removeItem("accessToken")
                  window.location.href="purchaser-auth/login"
              }
        }
        
      })
    }
    
    
    useEffect(()=>{    
    
      fetchPurchaserData()
      
      },[purchaserId,recall])



    useEffect(()=>{
        if(purchaserId){
            purchaserCtl.allFunds(purchaserId,(data)=>{
                if(data && !data.error){
                 setFunds(data)
                }
            })
        }
       
    },[purchaserId,])
  
    useEffect(()=>{
    if(purchaserData?.userInformation){
        setNewEmail(purchaserData?.userInformation?.email)
        setNewPhone(purchaserData?.userInformation?.phone)
        setNewFirstName(purchaserData?.userInformation?.contactFirstName)
        setNewLastName(purchaserData?.userInformation?.contactLastName)
    }
    },[purchaserData?.userInformation])

    const usDollarFunds = funds.filter(fund => fund.currencyName === "USD");
    




    
    const leaveAllModal = () => {
        setShowAlertMessage(false)
        setAddressModal(false)
    }
    const confirmRemoval = (e) => {
      setDeleteLoader(true)  
        e.target.disabled = true;
        if (!!purchaserData?.users) {
            representativeUsersClt.disableRepresentativeUser(purchaserId, id, (data) => {
                e.target.disabled = false;
                toggleConfirm();
                triggerReload();
                Notify(alert, 'success', "User have been Removed");
                // getPurchaserFunction()
                setTimeout(() => {
                    setDeleteLoader(false) 
                }, 1500);

            });
        } else {
            Notify(alert, 'danger', 'Something went wrong');
            toggleConfirm();
            setTimeout(() => {
                setDeleteLoader(false)
            }, 1500);
        }
    };

    const handleLowFund = (e) =>{
        setLowFundLoader(true)
        if(lowFund === undefined || lowFund === "" || lowFund.length < 1 ){
        Notify(alert,"danger","Lowfund Field can not be empty")
        setTimeout(() => {
         setLowFundLoader(false)   
        }, 1500);
        }else{
         let LowFundObj = {
            lowFundAlert : parseFloat(lowFund)
         }   
         purchaserCtl.lowFundCustomer(fundsData.id,LowFundObj,(data)=>{
            if(data && !data.error){
             Notify(alert,"success","Low funds upadated sucessfully") 
             toggleLowFund();
             setTimeout(() => {
                setLowFundLoader(false);
             }, 1500);
             purchaserCtl.allFunds(purchaserId,(data)=>{
                if(data && !data.error){
                 setFunds(data)
                }
            })
            }else{
                Notify(alert,"danger",data?.errorMessage)
                setTimeout(() => {
                   setLowFundLoader(false) 
                }, 1500);
            }
         })
        }
     
    }

    const prepareToAdd = () => {
        setActiveOp('Create New');
        toggle();
    };
    const prepareToEdit = (data) => {
        setActiveContact(data);
       setActiveOp('Edit');
        toggle();
       };

    const editLowFundData = (data)=>{
        toggleLowFund()
        setFundsData(data)
        setLowFund(data?.lowFundAlert)

    }
	const addLoaderFile = () =>{
        setTimeout(() => {
          setAddLoader(false);
        }, 1500);
      }

    const finishOperation = (e) => {
       e.target.disabled = true;
            if (!contactForm.current) return;
        
                const cv = new FromValidator(contactForm.current, (type, message) => Notify(alert, type, message),
                    [
                        {label: "", property: "id", input: "contactId", required: false},
                {label: "", property: "userId", input: "userId", required: false},
                        {label: "Contact Type", property: "purchaserContactTypeId", input: "contactTypeId", required: true, noVal: "-1"},
                        {label: "First Name", property: "contactFirstName", input: "contactFirstName", required: true},
                        {label: "Last Name", property: "contactLastName", input: "contactLastName", required: true},
                        {label: "Phone", property: "phone", input: "contactPhone", required: true, type: "phone"},
                        {label: "Mobile", property: "mobile", input: "contactMobile", required: false, type: "phone"},
                        {label: "Email", property: "email", input: "contactEmail", required: true, type: "email"}
                    ]
                );
        
                if (!cv.isFormValid())
                    return e.target.disabled = false;

                   const newContact = cv.getDTO();
                    newContact.purchaserId = purchaserId;
                    newContact.status = "new";
                    newContact.userId = null;
                    switch (activeOp) {
                      case 'Create New':
                        setAddLoader(true)
                        authCtl.checkIfUserExists(newContact.email, (verificationData) => {
                          if(!verificationData.valueOf()){
                            purchaserCtl.addContact(purchaserId, newContact, (data) => {
                              if(data && !data.error){
                                addLoaderFile();
                                toggle();
                                Notify(alert, 'success', 'Succesfully created contact');
                                triggerReload();
                              } else {
                                Notify(alert, 'danger', data.errorMessage ?? data.error);
                                addLoaderFile()
                                e.target.disabled = false;
                              }
                            });
                          } else {
                            Notify(alert, 'danger', 'Email not Available');
                            addLoaderFile();
                            return e.target.disabled = false;
                          }
                        });
                      break;
                      case 'Edit':
                        setEditLoader(true)
                        if(contactForm.current.contactEmail.disabled){
                          purchaserCtl.updateContact(purchaserId, newContact, data => {
                            if(data && !data.error){
                              editLoaderFile()
                              toggle();
                              Notify(alert, 'success', 'Succesfully updated contact');
                              triggerReload();
                            } else {
                              Notify(alert, 'danger', data.errorMessage ?? data.error);
                              editLoaderFile();
                              e.target.disabled = false;
                            }
                          });
                        } else {
                          authCtl.checkIfUserExists(newContact.email, verificationData => {
                            if(!verificationData.valueOf()){
                              purchaserCtl.updateContact(purchaserId, newContact, data => {
                                if(data && !data.error){
                                  toggle();
                                  editLoaderFile()
                                  Notify(alert, 'success', 'Succesfully updated contact');
                                  triggerReload();
                                } else {
                                  Notify(alert, 'danger', data.errorMessage ?? data.error);
                                  editLoaderFile()
                                  e.target.disabled = false;
                                }
                              });
                            } else {
                              Notify(alert, 'danger', 'Email not Available');
                              editLoaderFile();
                              return e.target.disabled = false;
                            }
                          });
                        }
                      break;
                      default: break;
                    }
           
    };

 
    const handleModalClose = () => {
        if (activeOp === 'Create New') {
                let hasChanges = false
                contactForm.current.forEach(el => {
                    if (!!el.value && el.value !== '-1') {
                        hasChanges = true
                    }
                })
    
                if (hasChanges) {
                    setShowAlertMessage(true)
                } else {
                    setModal(false)
                }
    
            } else {
                const formHasChanges = modelChange(activeContact, contactForm.current)
                if (formHasChanges){
                    setShowAlertMessage(true)
                } else {
                    setModal(!modal)
                }
            }
      }

    const modelChange = (initial, endModel) => {
		let changed = false
		Object.entries(initial).forEach(([key, value]) => {
			if (endModel[mapKeys[key]] && value !== endModel[mapKeys[key]].value) {
				changed = true
				return
			}
		})
		return changed
	}

    const ContactDelete = (data) =>{ 
        toggleDelete();
        setActiveContact(data);
    }
    
    const handleChangeContact = (e) => {
        setPurchaserData((prev) => ({
            ...prev,
            contactInformation: {
                ...purchaserData?.contactInformation,
                "purchaserId": purchaserId,
                [e.target.name]: e.target.value
            }
        }))
    }

    const handleUserInfochange = (e) =>{
      setNewEmail(e.target.value)
    }

    const handleUserPhonechange = (e) =>{
      setNewPhone(e.target.value)
    }
    const handleUserFirstNamechange = (e) =>{
       setNewFirstName(e.target.value)
    }
    const handleUserLastNamechange = (e) =>{
       setNewLastName(e.target.value)
    }


    const handleChangeBilling = (e) => {
        setPurchaserData((prev) => ({
            ...prev,
            billingInformation: {
                ...purchaserData?.billingInformation,
                [e.target.name]: e.target.value
            }
        }))

    }

    const handleSubmitContactInfo = (e) => {
        setContactLoader(true);
        const streetValue = purchaserData.contactInformation.street.trim();
        const postalValue  = purchaserData.contactInformation.postalCode.trim();
        const cityValue = purchaserData.contactInformation.city.trim();
			if (streetValue === "") {
				Notify(alert, "danger", "Street name cannot be blank");
                contactLoaderFile();
				return;
			}
            if (cityValue === "") {
				Notify(alert, "danger", "City cannot be blank");
                contactLoaderFile();
				return;
			}
        
            if (postalValue === "") {
				Notify(alert, "danger", "Postal Code cannot be blank");
                contactLoaderFile();
				return;
			}
        
        e.preventDefault();
        purchaserCtl.updatePurchaserContactInfo(purchaserData?.contactInformation, data => {
            if (data && !data.error) {
                Notify(alert, 'success', "Updated contact information successfully");
                toggleAddressModal("")
                // getPurchaserFunction()
                contactLoaderFile()
            } else {
                if(data?.error.includes("Server error response code: 500")){
                    Notify(alert,"danger","Internal Server Error");
                    contactLoaderFile()
                  }else{
                    Notify(alert, 'danger', data.errorMessage ?? data?.error)
                    contactLoaderFile()
                  }
            }
        });
    }

    const handleSubmitUserInfo = () =>{
         setUserLoader(true);
      let obj = {
        contactId:purchaserData?.userInformation?.id,
        newEmail:newEmail,
        newPhone:newPhone,
        newFirstName:newFirstName,
        newLastName:newLastName
      }
      purchaserCtl.updateUserInfo(obj,(data)=>{
        if(data && !data.error){
            Notify(alert,"success","User info update successfully")
            setUserLoader(false);
            toggleUserInfoModal()
            setRecall(true)
        }else{
            setTimeout(() => {
                setUserLoader(false);
            }, 1000);
            Notify(alert,"danger",data?.errorMessage ?? data?.error)
        }
      })
    }

    const handleSubmitBillingInfo = (e) => {
        setBillingLoader(true)
        const AdressValue = purchaserData?.billingInformation?.billingAddress?.trim();
        const postalValue  = purchaserData?.billingInformation?.billingPostalCode?.trim();
        const cityValue = purchaserData?.billingInformation?.billingCity?.trim();
			if (AdressValue === "") {
				Notify(alert, "danger", "Street name cannot be blank");
                billingLoaderFile()
				return;
			}
            if (cityValue === "") {
				Notify(alert, "danger", "City cannot be blank");
                billingLoaderFile()
				return;
			}
        
            if (postalValue === "") {
				Notify(alert, "danger", "Postal Code cannot be blank");
                billingLoaderFile()
				return;
			}
        e.preventDefault();
        purchaserCtl.updatePurchaserBillingInfo(purchaserId, purchaserData?.billingInformation, data => {
            if (data && !data.error) {
                Notify(alert, 'success', "Updated billing information successfully");
                toggleAddressModal("")
                // getPurchaserFunction();
                billingLoaderFile();
            } else {
                if(data?.error.includes("Server error response code: 500")){
                    Notify(alert,"danger","Internal Server Error");
                    billingLoaderFile();
                  }else{
                    Notify(alert, 'danger', data.errorMessage ?? data?.error)
                    billingLoaderFile();
                  }
            }
        });
    }
    const handleTableData = (e) =>{
     const tabledata = e.target.value;
      setCurrentItem(e.target.value);
      purchaserCtl.purchaserDetailsApi(purchaserId,tabledata, data => {
        if (!(data.error || data.errorMessage)) {
            setPurchaserData(data)
            setUsersList(data?.users)

        }
    })
    }
    //// function for global search ///////
    const handleSearchInputChange = (event) => {
        setSearchQuery(event.target.value);
        
        if (!event.target.value) {
            setUsersList(updatedContactData);
            return updatedContactData;
        } else {
            const searchQuery = event.target.value.trim().toLowerCase();
    
            const searchResults = updatedContactData?.filter((user) => {
                const fullName = `${user.contactFirstName} ${user.contactLastName}`.toLowerCase();
                const isMatch = Object.values(user).some((value) =>
                    value && value.toString().toLowerCase().includes(searchQuery)
                );
                const isMatchName = fullName.includes(searchQuery);
                return isMatch || isMatchName;
            });
    
            setUsersList(searchResults);
            return searchResults.length > 0 ? searchResults : "No match found";
        }
    };
    
    const changeContact = (data) =>{
       const contactId = usersList?.find(contact => contact.purchaserContactTypeId === 1)
        if(!contactId){
        Notify(alert, 'danger', 'No primary contact found');
        return;
        }
        setData(data)
        setContact(`${contactId?.contactFirstName} ${contactId?.contactLastName}`)
        toggleSetContact()
      const primaryContact = contactType?.filter(contactType => contactType.id !== 1)
      const options = primaryContact?.map(item =>({
         value: item?.id,
         label:item?.name
      }))
      setContactOption(options)
    }
  const handleNewContact = (option) =>{
    const value = option?.value
    setContactTypeId(value)

  }

    const updatePrimary = () =>{
    if(contactTypeId){
        setPrimaryLoader(true)
        if(contactTypeId === "-1"){
        Notify(alert, 'danger', 'select a contact');
        setTimeout(() => {
         setPrimaryLoader(false)
        }, 1500);
        return
        }
        setNewContactType(contactType.find(type => type.id === parseInt(contactTypeId)))
        setTimeout(() => {
            setPrimaryLoader(false)
        }, 1500);
        togglePrimaryConfirm()
    }
    }

    const confirmOperation = () =>{
        if(contactTypeId){
            purchaserCtl.setNewPrimary(purchaserId,data?.id, contactTypeId, (data)=>{
                if(data && !data.error){
                    togglePrimaryConfirm();
                    toggleSetContact();
                    triggerReload()
                    Notify(alert, 'info', 'Succesfully updated contact');  
                }else{
                    Notify(alert, 'danger', data.errorMessage ?? data.error)
                }
            })
        }else{
              Notify(alert, 'danger', 'Error in data');
              return
            }
    }
    
    return (
        <>
        {loader ?
            <div className='d-flex justify-content-center align-items-center flex-column vh-100'>
				<div className="spinner-border text-muted text-center"></div>
			</div>
            :
        <div className='dashboardPage profile'>
            <ConfirmationAlertTwo
                stayModal={stayModal} openModal={showAlertMessage} leaveModal={leaveAllModal}
            />
            <NotificationAlert ref={alert} />

            <Container className="mt-4" fluid style={{textAlign:"center"}}>
            
                <>
                <h5 className='mb-3'>Your Profile</h5>
                <div className="row">
                        <div className="col-lg-7 col-xl-8 order-1 order-lg-1">
                            <div className="card h-100 border-0 shadow-sm radius-0">
                                <div className="card-body p-0 border-bottom">
                                    <div className="p-4 text-left">
                                        <div className="row g-3 justify-content-between align-items-center mb-3">
                                        <div className="col-auto">
                                        <h6 className='mb-3'>User Information</h6>
                                        </div>
                                        
                                        <div className="col-auto" onClick={() => toggleUserInfoModal()}>
                                        <button className='btn btn-primaryTwo py-2'><i className='bx bxs-edit-location me-1' ></i>Edit</button>
                                        </div>
                                        </div>
                                       

                                        <div className="row g-3">
                                            <div className="col-md-6 text-left">
                                                <label htmlFor="" className="form-label ">Username</label>
                                                <input type="text" className='form-control' value={purchaserData?.userInformation?.email ? purchaserData?.userInformation?.email : '---'} disabled />
                                            </div>
                                            <div className="col-md-6 text-left">
                                                <label htmlFor="" className="form-label">Phone</label>
                                                <input type="text" className='form-control' value={purchaserData?.userInformation?.phone ? purchaserData?.userInformation?.phone : '---'} disabled />
                                            </div>
                                            <div className="col-md-6 text-left">
                                                <label htmlFor="" className="form-label">First Name</label>
                                                <input type="text" className='form-control' value={purchaserData?.userInformation?.contactFirstName ? purchaserData?.userInformation?.contactFirstName : '---'} disabled />
                                            </div>
                                            <div className="col-md-6 text-left">
                                                <label htmlFor="" className="form-label">Last Name</label>
                                                <input type="text" className='form-control' value={purchaserData?.userInformation?.contactLastName ? purchaserData?.userInformation?.contactLastName : '---'} disabled />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-xl-4 order-4 order-lg-2 mb-2">
                            <div className="card h-100 border-0 shadow-sm radius-0">
                                <div className="card-body p-0 ">
                                    <div className="p-4 text-center p_details">
                                        <i className='bx bx-dollar-circle display-1 gradient-textTwo' ></i>
                                        <h6>Available Funds</h6>
                                        <h2 className='gradient-textTwo fw-bold mb-2'> ${usDollarFunds.length > 0 ? usDollarFunds[0]?.funds?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "No USD funds"} </h2>
                                        

                                              <div className="col-auto" onClick={() => handleFundView()}>
                                                <button className='btn btn-primaryTwo py-2'><i className='bx bx-show me-1 '></i>View More</button>
                                            </div> 
                                        
                                    </div>
                                </div>
                                {/* <div className='d-flex' style={{height:"118x"}}>
                                  <div className='col-lg-8' style={{marginBottom:"18px",marginTop:"10px"}}>
                                  <label htmlFor="low funds" className="form-label">Set Lowfund Alert</label>
                                    <input type="number" className='form-control'id="low funds" placeholder='Enter Threshold Amount'  value={lowFund} onChange={(e)=>setLowFund(e.target.value)}/>
                                  </div>
                                  <div className="col-auto" onClick={() => handleLowFund()} style={{marginTop:"40px"}}>
                                    <button className='btn btn-primary py-2'><i className='bx bx-save me-1'></i>Save</button>
                                    </div> 
                                  
                                </div>
                                     <div>
                                        <h6>Low Fund Amount </h6>
                                        <h2 className='gradient-text fw-bold mb-2'>${ usDollarFunds.length > 0 ? usDollarFunds[0]?.lowFundAlert.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "No LowFund amount for USD Funds"}</h2>
                                    </div> */}
                            </div>
                        </div>
                        <div className="col-lg-7 col-xl-8 order-2 order-lg-3 mb-0 mb-lg-0">
                            <div className="card h-100 mb-0 mb-lg-0 shadow-sm radius-0">
                                <div className="card-body p-0">
                                    <div className="p-4">
                                        <div className="row g-3 justify-content-between align-items-center mb-3">
                                            <div className="col-auto">
                                                <h6 className=''>Contact Information</h6>
                                            </div>
                                            <div className="col-auto" onClick={() => toggleAddressModal("contact")}>
                                                <button className='btn btn-primaryTwo py-2'><i className='bx bxs-edit-location me-1' ></i>Edit</button>
                                            </div>
                                        </div>
                                        <Form innerRef={infoForm}>

                                            <div className="row g-3">
                                                <div className="col-md-8 text-left">
                                                    <label htmlFor="" className="form-label">Street</label>
                                                    <input type="text" value={contactData?.contactInformation?.street ? contactData?.contactInformation?.street : '---'} className='form-control' id={'input-address'} disabled />
                                                </div>
                                                <div className="col-md-4 text-left">
                                                    <label htmlFor="" className="form-label">Postal Code</label>
                                                    <input type="text" value={contactData?.contactInformation?.postalCode ? contactData?.contactInformation?.postalCode : '---'} className='form-control' id='input-postal-code' disabled />
                                                </div>
                                                <div className="col-md-6 text-left">
                                                    <label htmlFor="" className="form-label">City</label>
                                                    <input type="text" value={contactData?.contactInformation?.city ? contactData?.contactInformation?.city : '---'} className='form-control' id='input-city' disabled />
                                                </div>
                                                <div className="col-md-6 text-left">
                                                    <label htmlFor="" className="form-label">Country</label>
                                                    <input type="text" value={purchaserData?.contactInformation?.countryId ? countries.find(country => country.id === purchaserData?.contactInformation?.countryId)?.name || '---': '---'} className='form-control' id='input-country' disabled />
                                                </div>
                                            </div>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-xl-4 order-4 order-lg-4">
                            <div className="card h-100 p_details shadow-sm radius-0">
                                <div className="card-body p-0">
                                    <div className="p-4 text-center d-flex flex-column justify-content-center h-100">
                                        <p className='fs-5'>Users: <strong>{purchaserData?.totalUsers ? purchaserData?.totalUsers : '---'}</strong></p>
                                        <p className='fs-5'>Brands Available:  <strong>{purchaserData?.totalBrandsAvailable ? purchaserData?.totalBrandsAvailable : '---'}</strong></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7 col-xl-8 order-3 order-lg-5 mb-3 mb-lg-0">
                            <div className="card h-100 mb-3 mb-lg-0 shadow-sm radius-0">
                                <div className="card-body p-0">
                                    <div className="p-4">
                                        <div className="row g-3 justify-content-between align-items-center mb-3">
                                            <div className="col-auto">
                                                <h6 className=''>Billing Information</h6>
                                            </div>
                                            <div className="col-auto">
                                                <div className="row g-3 align-items-center">
                                                    {/* <div className="col-auto">
                                                        <Form.Check
                                                            reverse
                                                            label="Same as Contact Information"
                                                            name="group1"
                                                            type={'checkbox'}
                                                            id={`checkbox1`}
                                                            defaultChecked
                                                            disabled
                                                        />
                                                    </div> */}
                                                    <div className="col-auto">
                                                        <button onClick={() => toggleAddressModal("billing")} className='btn btn-primaryTwo py-2'><i className='bx bxs-edit-location me-1' ></i>Edit</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row g-3">
                                            <div className="col-md-8 text-left">
                                                <label htmlFor="" className="form-label">Street</label>
                                                <input type="text" value={contactData?.billingInformation?.billingAddress ? contactData?.billingInformation?.billingAddress : '---'} className='form-control' id='input-address' disabled />
                                            </div>
                                            <div className="col-md-4 text-left">
                                                <label htmlFor="" className="form-label">Postal Code</label>
                                                <input type="text" value={contactData?.billingInformation?.billingPostalCode ? contactData?.billingInformation?.billingPostalCode : '---'} className='form-control' id='input-postal-code' disabled />
                                            </div>
                                            <div className="col-md-6 text-left">
                                                <label htmlFor="" className="form-label">City</label>
                                                <input type="text" value={contactData?.billingInformation?.billingCity ? contactData?.billingInformation?.billingCity : '---'} className='form-control' id='input-city' disabled />
                                            </div>
                                            <div className="col-md-6 text-left">
                                                <label htmlFor="" className="form-label">Country</label>
                                                <input type="text" value={purchaserData?.billingInformation?.billingCoutryId ? countries.find(country => country.id === purchaserData?.billingInformation?.billingCoutryId)?.name || '---': '---'} className='form-control' id='input-country' disabled />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-xl-4 order-6 order-lg-6">
                            <div className="card h-100 p_details shadow-sm radius-0">
                                <div className="card-body p-0">
                                    <div className="p-4 text-center">
                                        <i className="bi bi-person display-1 gradient-textTwo"></i>
                                        <h6>Primary Contact </h6>
                                        <h4 className='fw-bold my-2'>{purchaserData?.primaryContactName ? purchaserData?.primaryContactName : '---'}</h4>
                                        <a href="mailto:ricardo@ncentiva.com">{purchaserData?.primaryContactEmail ? purchaserData?.primaryContactEmail : '---'}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                     
                    <div className="card table-widget">
                        <div className="card-body p-0">
                            <div className="border-bottom p-4">
                                <div className="row g-3">
                                    <div className="col-12 col-lg-12 col-xl-3">
                                        <div className="searchSort position-relative">
                                            <input onChange={(e) => handleSearchInputChange(e)} defaultValue={searchQuery} type="text" placeholder='Search' className='form-control pe-5' />
                                            <button className='d-flex align-items-center btn  position-absolute p-0 h-100 px-3'  style={{right:"0",top:"50%",transform:"translate(0%,-50%)",background: "#2665F2"}}><i className='bx bx-search'  style={{color:"white"}}></i></button>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 col-xl-6">
                                        {/* <div className="d-flex align-items-center">
                                            <label htmlFor="" className="form-label mb-0 me-2">Show</label>
                                            <select defaultValue={currentItem} onChange={(e) => handleTableData(e)} name="" id="" className='form-select w-auto'>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                        </div> */}
                                        <h6 className='mb-3'>Contact List</h6>
                                    </div>
                                 
                                    <div className="col-auto col-lg-auto ms-auto text-lg-end">
                                        <button className='btn btn-primaryTwo py-2' onClick={()=>prepareToAdd()}><i className='bx bxs-user me-1' ></i>  <span className='d-none d-xl-inline'>Create New Contact</span></button>
                                    </div>
                                </div>
                            </div>
                            <div className="p-4 table-responsive">
                                <table className="table table-borderless table-hover">
                                    <thead>
                                        <tr>
                                            <th>Name </th>
                                            <th>Email</th>
                                            <th style={{ width: "25%" }}>Phone Number </th>
                                            <th style={{ width: "10%" }}>Contact type </th>
                                            <th></th>
                                            <th style={{ width: '10%' }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {usersList?.length > 0 ? usersList?.map((data, index) => {
                                            const contactTypeId = contactType.find(type => type.id === data?.purchaserContactTypeId)
                                            return (

                                                <tr key={index}>
                                                    <td>{data?.contactFirstName} {" "} {data?.contactLastName}</td>
                                                    <td>{data?.email}</td>
                                                    <td>{data?.phone} </td>

                                                    <td>{contactTypeId?.name}</td>
                                                    <td>{data?.purchaserContactTypeId !== 1 ? <button class="btn btn-primaryTwo py-0 ncentiva-setPrimary-btn" onClick={()=>changeContact(data)}>Set as pimary</button> : ""}</td>
                                                    <td>
                                                    <div className="d-flex justify-content-center align-items-center">
                                                        <button onClick={() => ContactDelete(data)} className='btn btn-danger text-white delete' data-toggle="tooltip" data-placement="bottom" title='Delete'><i className="bi bi-x-lg"></i></button>
                                                        <button onClick={() => prepareToEdit(data)} className='btn btn-primaryTwo ms-2 edit' data-toggle="tooltip" data-placement="bottom" title='Edit'><i className="bi bi-pen"></i></button>
                                                    </div>
                                                    </td>
                                                </tr>
                                            )
                                        }) :
                                            <tr>
                                                <td colSpan={5}>No user added !</td>

                                            </tr>

                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {/* </div> */}
                </>
                
                <Modal isOpen={modal} toggle={toggle} backdrop="static" centered={true} size="md" onOpened={prepareForm}>
        <ModalHeader toggle={handleModalClose} className='custom_header_colourTwo'>{activeOp} contact</ModalHeader>
        <ModalBody>
          <ContactsCtl formRef={contactForm} />
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" onClick={handleModalClose}>Cancel</Button>
          <Button type="button" className='btn btn-primaryTwo' onClick={finishOperation} disabled={addLoader || editLoader}>Save{
            addLoader || editLoader &&
                   <Spinner
										as="span"
										animation="border"
										size="sm"
										role="status"
										aria-hidden="true"
										style={{
										margin: "0px 8px"
										}}
									/>
            }</Button>
        </ModalFooter>
      </Modal>
                <Modal isOpen={confirmModal} toggle={toggleConfirm} centered={true} backdrop="static">
                    <ModalHeader className="custom_header_colourTwo align-items-center" toggle={toggleConfirm}>
                        <h3 className='mb-0 ' style={{ fontSize: '20px',color:"white" }}>Remove User</h3>
                    </ModalHeader>
                    <ModalBody>
                        <p className="card-just-text">
                            Are you sure you want to remove the user "{rowData ? `${rowData?.firstName} ${rowData?.lastName}` : ""}?
                        </p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={toggleConfirm}>Cancel</Button>{' '}
                        <Button className='btn btn-primaryTwo' onClick={confirmRemoval} disabled={deleteLoader}>{!deleteLoader && "Yes"}{
                            deleteLoader && 
                            <Spinner
                               as="span"
                               animation="border"
                               size="sm"
                               role="status"
                               aria-hidden="true"
                               style={{
                                 margin: "0px 8px"
                               }}
                             />
                            }</Button>
                    </ModalFooter>
                </Modal>
                {editModalFlag == "contact" ?
                    <Modal isOpen={addressModal}
                        toggle={toggleAddressModal}
                        backdrop="static" centered={true} size="md"
                    // onOpened={prepareAddressForm}
                    >
                        <ModalHeader toggle={toggleAddressModal} className='custom_header_colourTwo d-flex align-items-center justify-content-between'>
                            <h2 className='mb-0' style={{color:"white"}}>Edit Address</h2>
                        </ModalHeader>
                        <ModalBody>
                            <Form>
                                <Row form>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label for="street">Street and number</Label>
                                            <Input type="text" id="street" defaultValue={purchaserData?.contactInformation?.street} name="street" onChange={handleChangeContact} placeholder="Street name, number and internal number" maxLength="70" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="city">City</Label>
                                            <Input type="text" id="city" name="city" defaultValue={purchaserData?.contactInformation?.city} onChange={handleChangeContact} placeholder="City" maxLength="50" />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="zipcode">Postal or Zip Code</Label>
                                            <Input type="text" name="postalCode" id="zipcode" defaultValue={purchaserData?.contactInformation?.postalCode} onChange={handleChangeContact} placeholder="Zip Code" maxLength="7" />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="countryId">Country</Label>
                                            <Input type="select" name="countryId" id="countryId" onChange={handleChangeContact} defaultValue={purchaserData?.contactInformation?.countryId}>
                                                <option hidden>Select a country</option>
                                                {countries?.map((data, index) => {
                                                    return (
                                                        <option key={index} value={data?.id}> {data?.name} </option>
                                                    )
                                                })}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Form>
                        </ModalBody>
                        <ModalFooter>
                            <Button type="button" color="secondary" onClick={toggleAddressModal}>Cancel</Button>
                            <Button type="button" className='btn btn-primaryTwo' onClick={handleSubmitContactInfo} disabled={contactLoader}>{!contactLoader &&"Save"}{
                               contactLoader && <Spinner
                               as="span"
                               animation="border"
                               size="sm"
                               role="status"
                               aria-hidden="true"
                               style={{
                                 margin: "0px 8px"
                               }}
                             />
                               }</Button>
                        </ModalFooter>
                    </Modal>
                    : editModalFlag == "billing" &&
                    <Modal isOpen={addressModal}
                        toggle={toggleAddressModal}
                        backdrop="static" centered={true} size="md"
                    // onOpened={prepareAddressForm}
                    >
                        <ModalHeader toggle={toggleAddressModal} className='custom_header_colourTwo d-flex align-items-center justify-content-between'>
                            <h2 className='mb-0' style={{color:"white"}}>Edit Address</h2>
                        </ModalHeader>
                        <ModalBody>
                            <Form >
                                <Row form>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label for="street">Street and number</Label>
                                            <Input type="text" id="street" onChange={handleChangeBilling} defaultValue={purchaserData?.billingInformation?.billingAddress} name="billingAddress" placeholder="Street name, number and internal number" maxLength="70" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="city">City</Label>
                                            <Input type="text" id="city" name="billingCity" onChange={handleChangeBilling} defaultValue={purchaserData?.billingInformation?.billingCity} placeholder="City" maxLength="50" />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="zipcode">Postal or Zip Code</Label>
                                            <Input type="text" name="billingPostalCode" id="zipcode" onChange={handleChangeBilling} defaultValue={purchaserData?.billingInformation?.billingPostalCode} placeholder="Zip Code" maxLength="7" />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="countryId">Country</Label>
                                            <Input type="select" name="billingCoutryId" id="countryId" onChange={handleChangeBilling} defaultValue={purchaserData?.billingInformation?.billingCoutryId}>
                                                <option hidden>Select a country</option>
                                                {countries?.map((data, index) => {
                                                    return (
                                                        <option key={index} value={data?.id}> {data?.name} </option>
                                                    )
                                                })}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Form>
                        </ModalBody>
                        <ModalFooter>
                            <Button type="button" color="secondary" onClick={toggleAddressModal}>Cancel</Button>
                            <Button type="button" className='btn btn-primaryTwo' onClick={handleSubmitBillingInfo} disabled={billingLoader}>{!billingLoader && "Save"}{
                                billingLoader && <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                style={{
                                  margin: "0px 8px"
                                }}
                              />
                         }</Button>
                        </ModalFooter>
                    </Modal>
                    
                }
                <Modal isOpen={fundShow} toggle={toggleFund} backdrop="static" centered={true} size="xl">
    <ModalHeader toggle={handleFundModalClose} className='custom_header_colourTwo'>Funds Information</ModalHeader>
    <ModalBody>
        <div className='table-responsive'>
        <table className="table">
            
            <thead>
        <tr>
            <th>Purchaser Name</th>
            <th>Funds</th>
            <th>Currency</th>
            <th>Prepaid Funds</th>
            
            {funds?.some(fund => fund.creditThreshold !== 0) && (
                <>
                    <th>Credit Threshold</th>
                    <th>Credit Limit</th>
                    
                </>
            )}
            <th>Low fund alert</th>
            <th></th>
        </tr>
    </thead>
    {/* <tbody>
        {funds?.length > 0 ? funds?.map((fund, index) => {
            if (fund.creditThreshold !== 0) {
                return (
                    <tr key={index}>
                        <td>{fund?.purchaserName}</td>
                        <td>${fund?.funds?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                        <td>{fund?.currencyName}</td>
                        <td>${fund?.prepaidFunds?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                        <td>${fund?.creditThreshold?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                        <td>${fund?.creditLimit?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                        
                    </tr>
                );
            } else {
                return (
                    <tr key={index}>
                        <td>{fund?.purchaserName}</td>
                        <td>${fund?.funds?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                        <td>{fund?.currencyName}</td>
                        <td>${fund?.prepaidFunds?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                        <td>${fund?.lowFundAlert.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                    </tr>
                );
            }
        }) : (
            <tr>
                <td colSpan={4}>No Data found</td>
            </tr>
        )}
    </tbody> */}

  <tbody>
    {funds?.length > 0 ? funds.map((fund, index) => (
        <tr key={index}>
            <td>{fund?.purchaserName}</td>
            <td>${fund?.funds?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
            <td>{fund?.currencyName}</td>
            <td>${fund?.prepaidFunds?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
            {fund.creditThreshold !== 0 && (
                <>
                    <td>${fund?.creditThreshold?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                    <td>${fund?.creditLimit?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                </>
            )}
            <td>${fund?.lowFundAlert?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
            <td>
            <button onClick={() => editLowFundData(fund)} className='btn btn-primaryTwo ms-2 edit edit_button' data-toggle="tooltip" data-placement="bottom" title='Edit'><i className="bi bi-pen"></i></button>
            </td>
           
        </tr>
    )) : (
        <tr>
            <td colSpan={funds?.some(fund => fund.creditThreshold !== 0) ? 8 : 6}>No data available</td>
        </tr>
    )}
 </tbody>

        </table>
        </div>
    </ModalBody>
    <ModalFooter>
        <Button type="button" color="secondary" onClick={handleFundModalClose}>Close</Button>
    </ModalFooter>
</Modal>
<Modal isOpen={lowFundModal} toggle={toggleLowFund} backdrop="static" centered={true} size="lg">
            <ModalHeader toggle={handlelowFundClose} className='custom_header_colourTwo'>Set Low Fund Alert</ModalHeader>
            <ModalBody>
                <div className='d-flex' style={{ height: "118px" }}>
                    <div className='col-lg-8' style={{ marginBottom: "18px", marginTop: "10px" }}>
                        <label htmlFor="low funds" className="form-label">Set Low Fund Alert</label>
                        <input
                            type="number"
                            className='form-control'
                            id="low funds"
                            placeholder='Enter Threshold Amount'
                            value={lowFund}
                            onChange={(e) => setLowFund(e.target.value)}
                        />
                    </div>
                    <div className="col-auto" onClick={handleLowFund} style={{ marginTop: "40px" }}>
                        <button className='btn btn-primaryTwo py-2' disabled={lowFundLoader}>
                            <i className='bx bx-save me-1'></i>Save{
                                lowFundLoader && <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                style={{
                                  margin: "0px 8px"
                                }}
                              />
                            }
                        </button>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
        <Button type="button" color="secondary" onClick={handlelowFundClose}>Close</Button>
       </ModalFooter>
        </Modal>
        <Modal isOpen={deleteModal} toggle={toggleDelete} backdrop="static" centered={true}>
				<ModalHeader className="custom_header_colourTwo align-items-center" toggle={toggleDelete}>
          <h3 className='mb-0' style={{fontSize:'20px',color:"white"}}>Remove Purchaser</h3>
        </ModalHeader>
				<ModalBody>
					<p className="card-just-text">
						Are you sure you want to remove the Contact "{!!activeContact && !!activeContact? `${activeContact.contactFirstName} ${activeContact.contactLastName}` : ""}"?
					</p>
				</ModalBody>
				<ModalFooter>
					<Button type="button" color="secondary" onClick={toggleDelete}>Cancel</Button>{' '}
					<Button type="button" className='btn btn-primaryTwo' onClick={confirmDelete} disabled={confirmLoader}>{!confirmLoader && "Yes"}{
            confirmLoader &&
                  <Spinner
										as="span"
										animation="border"
										size="sm"
										role="status"
										aria-hidden="true"
										style={{
										margin: "0px 8px"
										}}
									/>
       }</Button>
				</ModalFooter>
			</Modal>

            <Modal isOpen={primaryContactModal} toggle={toggleSetContact} backdrop="static" centered={true} size="md">
          <ModalHeader toggle={toggleSetContact} className=' custom_header_colourTwo'></ModalHeader>
          <ModalBody>
          <Form innerRef={primaryForm}>
            <Row form className="justify-content-center text-center">
                <Col md={8}>
                <FormGroup>
                    <Label for="contactSelect">Select new Contact Type for {contact}</Label>
                    <Select
                    id="contactSelect"
                    name="contactSelect"
                    options={contactOptions}
                    onChange={handleNewContact}
                    classNamePrefix="react-select"
                    placeholder="Select a contact type"
                    />
                </FormGroup>
                </Col>
            </Row>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary"  onClick={toggleSetContact}>Cancel</Button>
            <Button type="button" className='btn btn-primaryTwo' onClick={updatePrimary} disabled={primaryLoader}>{!primaryLoader && "Save"}{ 
            primaryLoader &&
            <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            style={{
            margin: "0px 8px"
            }}
          />
       }</Button>
          </ModalFooter>
      </Modal>

      <Modal isOpen={confirmPrimary} toggle={togglePrimaryConfirm} backdrop="static" centered={true} size='sm'>
        <ModalHeader className="custom_header_colourTwo" toggle={togglePrimaryConfirm}>
            Change contacts
        </ModalHeader>
        <ModalBody>
            <p className="card-just-text">
            Are you sure you want to set contact "{!!data ? `${data?.contactFirstName} ${data?.contactLastName}` : ""}" as Primary contact
            and "{!!contact ? contact : ""}" as {!!newContactType ? newContactType.name : ""}?
            </p>
        </ModalBody>
        <ModalFooter>
            <Button type="button" color="secondary" onClick={togglePrimaryConfirm}>Cancel</Button>{' '}
            <Button type="button" className='btn btn-primaryTwo' onClick={confirmOperation}>Yes</Button>
        </ModalFooter>
        </Modal>
             <Modal isOpen={userInfoModal}
                        toggle={toggleUserInfoModal}
                        backdrop="static" centered={true} size="md"
                    // onOpened={prepareAddressForm}
                    >
                        <ModalHeader toggle={toggleUserInfoModal} className='custom_header_colourTwo d-flex align-items-center justify-content-between'>
                            <h2 className='mb-0' style={{color:"white"}}>Edit User Information</h2>
                        </ModalHeader>
                        <ModalBody>
                            <Form>
                                <Row form>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label for="newEmail">User Name</Label>
                                            <Input type="text" id="newEmail" defaultValue={purchaserData?.userInformation?.email} name="newEmail" onChange={handleUserInfochange} placeholder="Street name, number and internal number" maxLength="70" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="newPhone">Phone</Label>
                                            <Input type="text" id="newPhone" name="newPhone" defaultValue={purchaserData?.userInformation?.phone} onChange={handleUserPhonechange} placeholder="City" maxLength="50" />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="NewFirstName">First Name</Label>
                                            <Input type="text" name="NewFirstName" id="NewFirstName" defaultValue={purchaserData?.userInformation?.contactFirstName} onChange={handleUserFirstNamechange} placeholder="Zip Code" maxLength="7" />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="NewLastName">Last Name</Label>
                                            <Input type="text" name="NewLastName" id="NewLastName" onChange={handleUserLastNamechange} defaultValue={purchaserData?.userInformation?.contactLastName} />
                                               
                                            
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Form>
                        </ModalBody>
                        <ModalFooter>
                            <Button type="button" color="secondary" onClick={toggleUserInfoModal}>Cancel</Button>
                            <Button type="button" className='btn btn-primaryTwo' onClick={handleSubmitUserInfo} disabled={userLoader}>{!userLoader &&"Save"}{
                               userLoader && <Spinner
                               as="span"
                               animation="border"
                               size="sm"
                               role="status"
                               aria-hidden="true"
                               style={{
                                 margin: "0px 8px"
                               }}
                             />
                               }</Button>
                        </ModalFooter>
                    </Modal>

            </Container>
        </div>
}
        </>
    )
}

export default Profile